import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  sendNotification,
  getStats,
  rowSelect,
} from '../../store/action/patient.action'
import {
  Row,
  Col,
  Button,
  Modal,
  Card,
  Form,
  Input,
  Badge,
  message,
} from 'antd'
import PatientNotify from './patient.notify.modal'
import _ from 'lodash'
import '../../css/patient.scss'
import { Link } from 'react-router-dom'
import { constants } from '../../constants'
import AddPatient from '../../pages/patient/addPatient'
import SelfRegistration from './patient.selfregistration'
const PatientAction = (props) => {
  useEffect(() => {
    props.getStats(props.customer?._id)
  }, [])
  
  useEffect(() => {
    if (!_.isEqual(statsData, props.stats)) {
      console.log('Setting statsData:', props.stats);
      setStatsData(props.stats);
    }
  }, [props.stats]);
  const [statsData,setStatsData]=useState()
  const [open, setOpen] = useState(false)

  var handleCancel = () => setOpen(false)

  var handleOpen = () => {
    if (props.selectedPatients?.key && props.selectedPatients.key.length > 0)
      setOpen(true)
    else message.error('Please select patient')
  }

  var handleSuccess = (data) => {
    data && props.resetSelectedPatients()
    !props.error && message.success('Notifications Sent!')
    setOpen(false)
  }
  const handleQrCode = () => {
    if (!props.customer?._id) return
    const qrCodeUrl = `${constants.API_URL}/registerform/${props.customer._id}`
    window.open(qrCodeUrl, '_blank', 'noopener,noreferrer')
  }
  return (
    <>
      <Row className={'actionRow'}>
        <Col flex={'200px'}>
          <Row className={'headerText'}>PATIENTS</Row>
          <Row>
            <p> {`Active: ${statsData?.active || '0'} | `} </p>&nbsp;
            {statsData?.surgeryTypes && statsData.surgeryTypes.length > 0 ? (
              statsData.surgeryTypes.map((surgType, index) => (
                <React.Fragment key={surgType.name}>
                  <p> {`${surgType.name.toUpperCase()}: ${surgType.count || '0'}`}{index < statsData.surgeryTypes.length - 1 ? ' | ' : ' '} </p>
                  {index < statsData.surgeryTypes.length - 1 && <>&nbsp;</>}
                </React.Fragment>
              ))
            ) : (
              <p style={{ color: '#999' }}>Loading surgery types...</p>
            )}
          </Row>
        </Col>
        <Col style={{ alignSelf: 'center' }} flex={'auto'}>
          <Row
            justify={'end'}
            align={'bottom'}
            style={{ alignSelf: 'center' }}
            gutter={25}
          >
            {props.user.role != constants.ROLE.COMPANY_HEALTHCOACH && (
              <Col style={{ alignSelf: 'center' }}>
                <Row justify={'end'} align={'bottom'}>
                  <SelfRegistration />
                  <Link to='/patient/add/info'>
                    <Button id={'patientadd'} className={'notifyBtn'}>
                      ADD
                    </Button>
                  </Link>
                  {/* Add patient with auth */}
                  {/* <AddPatient/> */}
                </Row>
              </Col>
            )}
            {/* <Col>
                        <Badge 
                          count={
                            Array.isArray(props.selectedPatients?.key) 
                              ? props.selectedPatients.key.length 
                              : 0
                          }
                       >
                        <Button className={"actionBtn"} onClick={handleOpen}  >NOTIFY</Button>
                        
                        </Badge>
                     </Col>
                        <Col>
                        <Button className={"actionBtn"} onClick={handleQrCode} >DOWNLOAD QR</Button>
                        </Col> */}
          </Row>
        </Col>
        <Col>&nbsp;</Col>
        <Col>
          <Row></Row>
        </Col>
      </Row>
      <PatientNotify
        patientids={props.selectedPatients?.key}
        visible={open}
        onClose={handleCancel}
        onSuccess={handleSuccess}
        showPatientsList={true}
      />
    </>
  )
}

PatientAction.propTypes = {
  sendNotification: PropTypes.func.isRequired,
  getStats: PropTypes.func.isRequired,
  selectedPatients: PropTypes.object,
  customer: PropTypes.object,
  stats: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    selectedPatients: state.patient?.selectedPatients,
    customer: state.profile.customer,
    error: state.patient.notifyError,
    message: state.patient.notifyMessage,
    stats: state.patient.stats,
    user: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendNotification: (params) => dispatch(sendNotification(params)),
    getStats: (params) => dispatch(getStats(params)),
    resetSelectedPatients: () => dispatch(rowSelect({})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientAction)
